import { createSelector } from '@reduxjs/toolkit';
import { selectLinkedAccounts } from '../../store/selectors';

export const selectAccounts = createSelector(selectLinkedAccounts, (linkedAccounts) => linkedAccounts.accounts);
